<template>
<svg :width="width" :height="height" :fill="color" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<title>icons/switch</title>
<g id="icons/switch" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
<!-- Top arc with arrowhead pointing right -->
<path d="M10,3 C13.866,3 17,6.134 17,10 C17,10.552 16.552,11 16,11 C15.448,11 15,10.552 15,10 C15,7.239 12.761,5 10,5 C8.327,5 6.839,5.788 5.868,7 L7.5,7 C8.052,7 8.5,7.448 8.5,8 C8.5,8.552 8.052,9 7.5,9 L4,9 C3.448,9 3,8.552 3,8 L3,4.5 C3,3.948 3.448,3.5 4,3.5 C4.552,3.5 5,3.948 5,4.5 L5,5.764 C6.282,4.068 8.02,3 10,3 Z" id="top-arrow" :fill="color" fill-rule="nonzero"></path>
<!-- Bottom arc with arrowhead pointing left -->
<path d="M10,17 C6.134,17 3,13.866 3,10 C3,9.448 3.448,9 4,9 C4.552,9 5,9.448 5,10 C5,12.761 7.239,15 10,15 C11.673,15 13.161,14.212 14.132,13 L12.5,13 C11.948,13 11.5,12.552 11.5,12 C11.5,11.448 11.948,11 12.5,11 L16,11 C16.552,11 17,11.448 17,12 L17,15.5 C17,16.052 16.552,16.5 16,16.5 C15.448,16.5 15,16.052 15,15.5 L15,14.236 C13.718,15.932 11.98,17 10,17 Z" id="bottom-arrow" :fill="color" fill-rule="nonzero"></path>
</g>
</svg>
</template>
<script>
export default {
  name: 'switchSvg', // vue component name
  props: {
    color: {
      type: String,
      default: 'gray'
    },
    width: {
      type: String,
      default: '40px'
    },
    height: {
      type: String,
      default: '40px'
    }
  },
  data () {
    return {
    }
  }
}
</script>
